/* eslint-disable no-unused-vars */
import React from 'react';
import {Image, Title} from './../../Basics';
import Particle from './../../Particle';
/* eslint-enable no-unused-vars */

const Particle23 = () => (<div>

  <Title>The winners</Title>

  <Image
    source={require('./23_Bild_4_WHEEL_Team_HSR-Enhanced_AlessandroDellaBella_115.jpg')}
    title='Winner wheelchair circuit'
    caption={
      <span>
      <b>Wheelchair circuit</b>
     Pilot Florian Hauser (right), HSR Enhanced, Switzerland, with project leader Christian Bermes
      </span>
    }
  />

  <Particle
    number={27}
  />

  <Image
    source={require('./23_Bild_1_ARM_Gold-Medal_Team-DIPO-Power_AlessandroDellaBella_095.jpg')}
    title='Winner arm prosthesis dexterity course'
    caption={
      <span>
      <b>Arm prosthesis dexterity course</b>
      Gold medal: Robert Radocy (second from the right), DIPO Power team, the Netherlands
      <b/>
      Silver medal: Patrick Mayrhofer (second from the left), Michelangelo team, Germany
      </span>
    }
  />
 
  <Image
    source={require('./23_Bild_2_LEG_Team_OssurRheoKnee_NicolaPitaro_7953.jpg')}
    title='Winner prosthetic leg course'
    caption={
      <span>
      <b>Prosthetic leg course</b>
      Helgi Sveinsson, RHEO KNEE team, Iceland
      </span>
    }
  />

  <Image
    source={require('./23_Bild_3_BCI_Team_Brain-Tweakers_NicolaPitaro_7881.jpg')}
    title='Winner virtual race via thought control'
    caption={
      <span>
      <b>Virtual race via thought control</b>
      NNuma Poujouly, Brain Tweakers team, Switzerland
      </span>
    }
  />

  <Image
    source={require('./23_Bild_5_EXO_Team_ReWalk_NicolaPitaro_7012.jpg')}
    title='Winner exoskeleton obstacle course'
    caption={
      <span>
      <b>Exoskeleton obstacle course</b>
      André Van Rüschen (center) with the ReWalk team, Germany
      </span>
    }
  />

  <Image
    source={require('./23_Bild_6_FES_Team-Cleveland_NicolaPitaro_8098.jpg')}
    title='Winner bike race by means of muscle stimulation'
    caption={
      <span>
      <b>Bike race by means of muscle stimulation</b>
      Mark Muhn, Cleveland team, USA
      <br/>
      Fotos: ETHZ
      </span>
    }
  />

<Particle
number={2}
/>


</div>);

export default Particle23;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle23/Particle23_EN.js
 **/